import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { faCar, faCheck, faCreditCard, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { CrossBorderModel } from 'src/app/models/Booking/CrossBorderModel';
import { DriverSkillModel } from 'src/app/models/Booking/DriverSkillModel';
import { OneWayRentalModel } from 'src/app/models/Booking/OneWayRentalModel';
import { VehicleReservationCaseManualCharges, VehicleReservationCaseRentalPeriodModel, VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { AgeRestrictionPolicyTypes, DepositPolicyPaymentTypes, DiscountScopeEnum, PolicyType, PredefinedAdditionalServiceEnum, RentalDeliveryTypeEnum, VehicleReservationState } from 'src/app/models/enums/BookingEnums';
import { ViewBookingViewModeEnum } from 'src/app/models/enums/ViewBooking/ViewBookingEnum';
import { Vehicle } from 'src/app/models/Vehicle';
import { LstAdditionalServiceOnReturnReservationCaseModel, LstAdditionalServiceReservationCase, LstPolicyReservationCaseModel, LstVehicleReservationCaseNonWorkingHoursChargeModel, VehicleReservationCaseAccidentChargeModel, VehicleReservationCaseDamageModel, VehicleReservationCaseDetailsModel, VehicleReservationCaseEazyRentServiceModel, VehicleReservationCaseFinesModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { BookingService } from 'src/app/services/booking.service';
import { SearchService } from 'src/app/services/search.service';
import * as uuid from 'uuid';
import { AuthService } from './../../../services/auth.service';

//#endregion Helper Discount class
class FreeService {
  additionalServiceID: number;
  predefinedAdditionalServiceID: number;
  quantity?: number;
  isQuantitative
}
class FreePolicy {
  FreePolicyID: number;
  policyType: number;
  policyDefinitionID: number;
  policyTypeName: string;
  lang: string;

}
//#endregion

@Component({
  selector: 'charge-summary-view-booking',
  templateUrl: './charge-summary-view-booking.component.html',
  styleUrls: ['./charge-summary-view-booking.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChargeSummaryViewBookingComponent implements OnInit, OnDestroy {

  faCreditCard = faCreditCard;
  faCar = faCar;
  faMoneyBillWave = faMoneyBillWave;
  faCheck = faCheck;
  subscriptions: Subscription[] = [];
  @Input() reservationCaseData: any;
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;
  vehicleReservationCaseResult: VehicleReservationCaseResult;
  lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[];
  manualCharges: VehicleReservationCaseManualCharges[];
  form: FormGroup;
  formControlPrefix = 's_';
  formControlTotalPostfix = '_total';
  formControlTogglePostfix = '_toggle';
  currency;
  //Tax variables
  taxableAmount: number;
  totalTax: number;
  taxPercent: number;
  //Duration In Days
  durationInDays: number;
  totalPrice: number;
  chargeSummary: any;
  vehicle: Vehicle;

  //#region  Discount Variables
  freePolicies: FreePolicy[] = [];
  freeServices: FreeService[] = [];
  //#endregion
  customerAge: number;
  ageResrictionPolicyFlag = false;
  ageRestrectionCharge: number = 0;


  selectedBorders;
  viewBooking: ViewBookingModel;
  vehicleReservationCaseRentalPeriodModel: VehicleReservationCaseRentalPeriodModel[];
  subTotal: number;
  lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[];
  @Input() newDurationData;
  @Input() newDurationExtendData;
  @Input() unavailableAditionalServiceData; //For Extend Mode , and Incase there Is some service unavailable
  @Input() oneWayRentalServiceData;
  @Input() viewBookingViewMode: ViewBookingViewModeEnum;
  @Output() onTotalCalculated = new EventEmitter();

  rentalPeriodModel: VehicleReservationCaseRentalPeriodModel;
  oldRentalPeriod: any;
  extendRentalPeriodModel: VehicleReservationCaseRentalPeriodModel;
  ezRent: VehicleReservationCaseEazyRentServiceModel[];
  oneWayRentalExtendFlag: boolean;
  originalLstAdditionalServiceReservationCase: any;
  lstDamages: VehicleReservationCaseDamageModel[];
  lstFines: VehicleReservationCaseFinesModel[];
  lstAccident: VehicleReservationCaseAccidentChargeModel[];
  subTotalBeforeDiscount: number;
  lstVehicleReservationCaseNonWorkingHoursChargeModel: LstVehicleReservationCaseNonWorkingHoursChargeModel[];
  compensatedItems: LstAdditionalServiceOnReturnReservationCaseModel[];
  calculateTotalResult: number = 0;
  deposiePolicy: LstPolicyReservationCaseModel;

  constructor(
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private bookingService: BookingService,
    searchService: SearchService,
    private _formBuilder: FormBuilder) {
    this.currency = searchService.getCurrency();


  }
  ngOnDestroy(): void {

    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }
  ngOnInit() {

    this.chargeSummary = {
      durationUnit: "D"
    }
    this.subscriptions.push(this.bookingService
      .vehicle
      .subscribe(res => { this.vehicle = res; }));


    this.form = this._formBuilder.group({
    });
    this.authService.loggedInCustomer.subscribe(customer => {
      if (customer != null) {
        this.customerAge = customer.age;
      }

    })
    this.subscriptions.push(this.bookingService.vehicleReservationCaseResult.subscribe(res => {


      this.ezRent = res.vehicleReservationDetailsModel.lstVehicleReservationCaseEazyRentServiceModel;
      this.lstDamages = res.vehicleReservationDetailsModel.lstVehicleReservationCaseDamageModel;
      this.lstFines = res.vehicleReservationDetailsModel.lstVehicleReservationCaseFinesModel;
      this.lstAccident = res.vehicleReservationDetailsModel.lstVehicleReservationCaseAccidentChargeModel;
      this.compensatedItems = res.vehicleReservationDetailsModel.lstAdditionalServiceOnReturnReservationCaseModel;
      this.manualCharges = res.vehicleReservationCaseManualCharges;
      this.lstVehicleReservationCaseNonWorkingHoursChargeModel = res.vehicleReservationDetailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel;
      this.vehicleReservationCaseRentalPeriodModel = res.vehicleReservationCaseRentalPeriodModel;
      this.calculateTotalForManualCharge(res.vehicleReservationCaseManualCharges);
      this.loadData2(res);
      this.cd.markForCheck();




    }))

    //Incase Update rental period
    if (this.newDurationData != null) {
      this.subscriptions.push(this.newDurationData.subscribe(res => {


        if (res != null) {

          let rentalPeriodModel = this.vehicleReservationCaseRentalPeriodModel[0];

          if (rentalPeriodModel != null) {
            this.oldRentalPeriod = rentalPeriodModel;
            //this.rentalPeriodModel = rentalPeriodModel;

            //Deep Copy for Rental Period
            //To Prevent two way changing in non-related component
            this.rentalPeriodModel = Object.assign([], this.rentalPeriodModel, rentalPeriodModel);
            //rentalPeriodModel.durationUnitCode=res.rateTypeCodeName;
            rentalPeriodModel.rentalUnitPrice = res.rentalUnitPriceNewDuration;
            rentalPeriodModel.durationUnit = res.durationUnit;
            rentalPeriodModel.totalRentalPrice = res.totalRentalDuration;
            rentalPeriodModel.durationUnitCode = res.rateTypeCodeName;
            this.durationInDays = res.durationInDaysNewDuration;
            this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
          }
        }
        //IF Cancel the new rental , restore the old period
        else {

          if (this.rentalPeriodModel != null) {
            this.vehicleReservationCaseRentalPeriodModel[0] = this.rentalPeriodModel;
            this.durationInDays = this.viewBooking.durationInDays;
            this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
          }

        }

        if (res != null && res.lstVehicleReservationCaseNonWorkingHoursChargeModel != null) {
          this.lstVehicleReservationCaseNonWorkingHoursChargeModel = res.lstVehicleReservationCaseNonWorkingHoursChargeModel;
          this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
        }
      }));
    }


    //Incase Extend Rental period
    if (this.newDurationExtendData != null) {


      this.subscriptions.push(this.newDurationExtendData.subscribe(res => {


        debugger
        if (res != null) {

          if (this.extendRentalPeriodModel == null) {
            let newPeriod: VehicleReservationCaseRentalPeriodModel = {
              vehicleReservationCasesRentalPeriodID: uuid.v4(),
              rentalUnitPrice: res.rentalUnitPriceNewDuration,
              durationUnit: res.durationUnit,
              totalRentalPrice: res.totalRentalDuration,
              durationUnitCode: res.rateTypeCodeName,
            }
            this.extendRentalPeriodModel = newPeriod;

            this.vehicleReservationCaseRentalPeriodModel.push(newPeriod);
            this.durationInDays = res.totalDurationInDays;
            //this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
          }
          else {
            let extendPeriodIndex = this.vehicleReservationCaseRentalPeriodModel.findIndex(a => a.vehicleReservationCasesRentalPeriodID == this.extendRentalPeriodModel.vehicleReservationCasesRentalPeriodID);
            if (extendPeriodIndex > -1) {
              this.vehicleReservationCaseRentalPeriodModel.splice(extendPeriodIndex, 1);
            }
            let newPeriod: VehicleReservationCaseRentalPeriodModel = {
              vehicleReservationCasesRentalPeriodID: uuid.v4(),
              rentalUnitPrice: res.rentalUnitPriceNewDuration,
              durationUnit: res.durationUnit,
              totalRentalPrice: res.totalRentalDuration,
              durationUnitCode: res.rateTypeCodeName,
            }
            this.extendRentalPeriodModel = newPeriod;

            this.vehicleReservationCaseRentalPeriodModel.push(newPeriod);
            this.durationInDays = res.totalDurationInDays;
            //this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);

          }


        }
        //IF Cancel the new rental , restore the old period
        else {
          if (this.extendRentalPeriodModel != null) {
            let extendPeriodIndex = this.vehicleReservationCaseRentalPeriodModel.findIndex(a => a.vehicleReservationCasesRentalPeriodID == this.extendRentalPeriodModel.vehicleReservationCasesRentalPeriodID);
            if (extendPeriodIndex > -1) {
              this.vehicleReservationCaseRentalPeriodModel.splice(extendPeriodIndex, 1);
            }
            this.durationInDays = this.viewBooking.durationInDays;
            //this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
          }

        }


        //If there is NonWorkingHours Object
        //Check if there is already non-working fees
        if (res != null && this.lstVehicleReservationCaseNonWorkingHoursChargeModel != null
          && this.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0) {
          //Check if one on them is return fees
          let returnNonWorkingHours = this.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];
          //IF yes, then delete it ,because we will replace it with new fees "IF EXIST"
          if (returnNonWorkingHours != null) {
            var index = this.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(returnNonWorkingHours);
            this.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);
          }

        }

        //The Result will have  only data for return non workring hours, so nothing to do for pickup
        if (res != null && res.lstVehicleReservationCaseNonWorkingHoursChargeModel != null) {
          //ADD The new fees
          res.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(element => {
            this.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(element);
          });
          //this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
        }


        if (res != null && res.objAdditionalServiceReservationCaseModel != null) {
          let oneWayRental = res.objAdditionalServiceReservationCaseModel;
          let oneWayRentalServiceIndex = this.lstAdditionalServiceReservationCase.findIndex(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService);
          //Delete currentOneWayRental if exist
          if (oneWayRentalServiceIndex > -1) {
            this.lstAdditionalServiceReservationCase.splice(oneWayRentalServiceIndex, 1);
          }
          //Add New One Way rental
          oneWayRental.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService;
          this.lstAdditionalServiceReservationCase.push(oneWayRental);

          this.updateFormDynamically(oneWayRental);
          //this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
        }


        this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
      }))
    }

    //Incase Extend Rental period and there is some additional service unavialble
    if (this.unavailableAditionalServiceData != null) {

      this.unavailableAditionalServiceData.subscribe(res => {

        if (res != null) {

          let unavialbleAditionalServiceID: number[] = res.map(a => a.additionalServiceID);

          this.lstAdditionalServiceReservationCase = this.lstAdditionalServiceReservationCase.filter(a => !unavialbleAditionalServiceID.includes(a.additionalServiceID));
          this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
        }
        //IF Cancel the new rental , restore the old period
        else {

        }
      })
    }


    //Incase Extend Rental period and there is some additional service unavialble
    if (this.oneWayRentalServiceData != null) {

      this.subscriptions.push(this.oneWayRentalServiceData.subscribe(res => {
        if (this.originalLstAdditionalServiceReservationCase != null) {
          this.originalLstAdditionalServiceReservationCase = Object.assign([], this.originalLstAdditionalServiceReservationCase, this.lstAdditionalServiceReservationCase);
        }

        if (res != null) {

          if (Object.keys(res).length == 0) {
            let oneWayRentalIndex = this.lstAdditionalServiceReservationCase.findIndex(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService);
            this.lstAdditionalServiceReservationCase.splice(oneWayRentalIndex);
            this.oneWayRentalExtendFlag = true;
            this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
            return;
          }

          if (res.restoreOriginal) {
            this.lstAdditionalServiceReservationCase = this.originalLstAdditionalServiceReservationCase;
          }
          if (this.lstAdditionalServiceReservationCase != null) {
            let oneWayRentalIndex = this.lstAdditionalServiceReservationCase.findIndex(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService);
            if (oneWayRentalIndex == -1) {
              this.lstAdditionalServiceReservationCase.push(res);
              this.updateFormDynamically(res);
              this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
            }
            else {
              this.lstAdditionalServiceReservationCase.splice(oneWayRentalIndex);
              this.lstAdditionalServiceReservationCase.push(res);
              this.oneWayRentalExtendFlag = true;
              this.updateFormDynamically(res);
              this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
            }

            //this.lstAdditionalServiceReservationCaseBackUp =this.lstAdditionalServiceReservationCase;

          }
        }
        else {
          let oneWayRentalIndex = this.lstAdditionalServiceReservationCase.findIndex(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService);
          if (oneWayRentalIndex > -1 && this.oneWayRentalExtendFlag) {
            this.lstAdditionalServiceReservationCase.splice(oneWayRentalIndex);
            this.totalPrice = this.calculateTotal(this.lstAdditionalServiceReservationCase);
          }
        }

      }))
    }


    this.selectedBorders = this.bookingService.selectedBorders;
  }




  get f() { return this.form.controls; }

  loadData() {
    this.bookingService.vehicleReservationCaseResult.subscribe(res => {

      if (res != null) {

        this.viewBooking = this.bookingService.reservationCaseToViewBookingModel(res);
        this.vehicleReservationCaseResult = res;
        //this.lstAdditionalServiceReservationCase = this.viewBooking.lstAdditionalServiceReservationCase;



        this.lstAdditionalServiceReservationCase = res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase;
        this.Initlize(res);
      }

    });
  }
  get policyType(): typeof PolicyType {
    return PolicyType;
  }

  get VehicleReservationState(): typeof VehicleReservationState {
    return VehicleReservationState;
  }

  get discountScope(): typeof DiscountScopeEnum {
    return DiscountScopeEnum;
  }
  get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }
  get ViewBookingViewMode() {
    return ViewBookingViewModeEnum;
  }
  get depositPolicyPaymentTypes() {
    return DepositPolicyPaymentTypes;
  }
  public get campaignsReservationCaseModel() {
    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel : null;
  }
  public get membershipModel() {

    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.membershipModel : null;
  }
  public get agencyEmployeeAllowedDiscountsModel() {
    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.agencyEmployeeAllowedDiscountsModel : null;
  }
  get isAllFreeNonWorkingHour() {


    let list = this.lstVehicleReservationCaseNonWorkingHoursChargeModel;
    if (list != null && list.length > 0) {
      let isWorkingNotHourFree = list.filter(a => a.isActive && a.unitPrice > 0)[0];
      if (isWorkingNotHourFree != null) {
        return false
      }
      else {
        return true;
      }
    }
    return false;
  }
  get totalRentalPrice() {

    if (this.vehicleReservationCaseRentalPeriodModel != null) {
      let sum = 0;
      this.vehicleReservationCaseRentalPeriodModel.forEach(i => {
        sum += i.totalRentalPrice;
      })
      return sum;
    }
    else {
      return 0;
    }
  }

  get isNoDeposiePolicy(): boolean {
    if (this.freePolicies != null) {
      let depositePolicy = this.freePolicies.filter(a => a.policyDefinitionID == PolicyType.DepositPolicy)[0];
      if (depositePolicy != null) {
        return true;
      }
    }
    return false;
  }

  loadData2(res: VehicleReservationCaseResult) {

    if (res != null) {

      this.viewBooking = this.bookingService.reservationCaseToViewBookingModel(res);
      this.vehicleReservationCaseResult = res;



      this.durationInDays = this.viewBooking.durationInDays
      this.taxPercent = this.viewBooking.taxPercentage / 100;
      this.vehicleReservationCaseRentalPeriodModel = this.viewBooking.vehicleReservationCaseRentalPeriodModel;

      this.vehicleReservationCaseDetailsModel = this.viewBooking.vehicleReservationDetailsModel;
      //Todo: Make one code for both mode
      this.freePolicies = this.getFreePolicies(this.viewBooking.vehicleReservationDetailsModel);
      this.freeServices = this.getFreeServices(this.viewBooking.vehicleReservationDetailsModel);
      this.lstPolicyReservationCaseModel = this.viewBooking.lstPolicyReservationCaseModel;
      if (this.lstPolicyReservationCaseModel != null) {
        this.deposiePolicy = this.lstPolicyReservationCaseModel.filter(a => a.policyDefinitionId == PolicyType.DepositPolicy)[0];
      }

      //this.calculateAgeRestrictionPolicy(this.lstPolicyReservationCaseModel);

      this.lstAdditionalServiceReservationCase = res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase;

      this.Initlize(res);
    }
  }
  Initlize(res) {
    this.form = this._formBuilder.group({
    });
    res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase.forEach(element => {
      this.updateFormDynamically(element);

    });

    this.totalPrice = this.calculateTotal(res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase);
  }
  //Get the VehicleReservationCaseDetailsModel and Iterate it
  //Build the form based on the predefinedAdditionalServiceID and what it have (DropDown, List of values ..etc)
  //The default case is only number or toggle without number
  updateFormDynamically(element: LstAdditionalServiceReservationCase) {


    if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID,
        new FormGroup({
          PickUpToggle: new FormControl({ value: this.viewBooking.isPickupAddress, disabled: false }),
          PickUpLocationName: this.viewBooking.isPickupAddress ? new FormControl({ value: this.viewBooking.pickupAddress, disabled: false }) : new FormControl({ value: '', disabled: false }),
          PickUpLocation: new FormControl(''),
          ReturnToggle: new FormControl({ value: this.viewBooking.isReturnAddress, disabled: false }),
          ReturnLocationName: this.viewBooking.isReturnAddress ? new FormControl({ value: this.viewBooking.returnAddress, disabled: false }) : new FormControl({ value: '', disabled: false }),
          ReturnLocation: new FormControl(''),
        }),
      )
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.CrossingBoarders) {

      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + '_Borders', new FormArray([]));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: element.lstCrossBorderModel, disabled: false }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: element.totalQuantityUsedForCase, disabled: false }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl(0));
      let oneWayRentalObj: OneWayRentalModel = {
        charge: element.unitPrice,
        isTaxsable: element.isTaxable,


      }
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: oneWayRentalObj, disabled: false }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {

      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.viewBooking.selectedSkillIds
      let selectedSkils = element.agencyDriverBaseRatesSkills.filter(o => this.viewBooking.selectedSkillIds.includes(o.driverSkillID + ""));

      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: selectedSkils, disabled: false }))
    }
    else {

      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: element.totalQuantityUsedForCase, disabled: false }))
    }



  }
  calculatePrice(additionalService: LstAdditionalServiceReservationCase, isQuantable, quantity?) {
    let total = 0;
    if (additionalService.isPerDay) {
      total = additionalService.unitPrice * this.durationInDays;
    }
    else {
      total = additionalService.unitPrice;
    }

    if (isQuantable) {
      //let quantity=this.form.controls[this.formControlPrefix+additionalService.additionalServiceID].value;
      total = total * quantity;
    }

    return total;

  }



  calculatePriceDriverSkill(additionalService: LstAdditionalServiceReservationCase, skills: DriverSkillModel[]) {
    //here we will always multiply by duration (* DurationInDays)
    //(Sum of selected skills rate + Driver Rate) * DurationInDays

    /* let skillRateSum = 0;
    skills.forEach(element => {
      skillRateSum += element.driverSkillRate;
    });
    return (additionalService.driverRate + skillRateSum) * this.durationInDays; */
    //Incase of View Mode
    return additionalService.unitPrice * this.durationInDays;
  }
  calculatePriceOneWayRental(additionalService: LstAdditionalServiceReservationCase, skills: OneWayRentalModel) {

    //Here there is no duration and no Unit price

    let skillRateSum = 0;
    skillRateSum += skills.charge;
    return skillRateSum;
  }
  calculatePriceCrossingBorderViewMode(model: CrossBorderModel) {
    return model.charge;
  }

  calculateTax(price, tax) {
    return price * tax;
  }

  calculateTotal(lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[]) {

    if (lstAdditionalServiceReservationCase == null)
      return

    this.taxableAmount = 0;
    this.totalTax = 0;
    let totalPrice = 0;
    let subTotal = 0;


    //  if(this.form.dirty){


    // if (lstAdditionalServiceReservationCase != null) {
    //Todo: cache the previeous model and compare if no change do not do anything.
    //Recomened : change the  Detection Strategey to be OnPush but it need to update the input()



    lstAdditionalServiceReservationCase.forEach(element => {
      debugger
      let servicePrice = 0;
      let serviceTax = 0;
      let amountTaxed = 0;
      let control = this.form.controls[this.formControlPrefix + element.additionalServiceID];
      let controlToggle = this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix];
      let controlTotal = this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix];
      let _freeService = this.freeServices.filter(o => o.additionalServiceID == element.additionalServiceID || o.predefinedAdditionalServiceID == element.predefinedAdditionalServiceID)[0];
      let freeQuantity = 0;
      if (controlToggle.value) {

        switch (element.predefinedAdditionalServiceID) {
          case PredefinedAdditionalServiceEnum.AdditionalDrivers:

            //Check if the current service exist in the free services list

            //Check the quantity because the Current Service is Quantitative
            // if (_freeService != null && _freeService.quantity != null) {
            //   freeQuantity = _freeService.quantity;
            // }
            // //If the total of quaity is more than free , then start calculate the price
            // if (control.value > freeQuantity) {
            //   //We will start calculating from the first quantity after the free quantity number
            //   servicePrice = this.calculatePrice(element, true, (control.value - freeQuantity));
            // }

            servicePrice = element.totalPrice;
            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

            }
            totalPrice += servicePrice;
            break;
          case PredefinedAdditionalServiceEnum.Drivers:

            if (control.value != null && Object.keys(control.value).length > 0) {

              // let driverModelList = control.value as DriverSkillModel[]; //Todo: multiple select

              // //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              // if (_freeService == null) {
              //   servicePrice = this.calculatePriceDriverSkill(element, driverModelList);
              // }

              servicePrice = element.totalPrice;
              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }
            else {
              let driverModelList = [];

              //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              // if (_freeService == null) {
              //   servicePrice = this.calculatePriceDriverSkill(element, driverModelList);
              // }
              servicePrice = element.totalPrice;
              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }

            break;
          case PredefinedAdditionalServiceEnum.OneWayRentalService:

            //Todo: how to compute tax for this
            if (Object.keys(control.value).length > 0) {
              // let oneWayRentalModel = control.value as OneWayRentalModel;   //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              // if (_freeService == null) {
              //   servicePrice = this.calculatePriceOneWayRental(element, oneWayRentalModel);
              // }

              servicePrice = element.totalPrice;

              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }
            break
          case PredefinedAdditionalServiceEnum.RentalDelivery:




            let crossingBorderForm = control.value as FormGroup;

            //If its not Quantitative then calculate the service price if its not exist in the FreeService list
            if (_freeService == null) {

              //Here we have two toggle One for pickup and one for return
              if (crossingBorderForm['PickUpToggle']) {
                //update the price and total price
                //servicePrice +=  this.calculatePrice(element, false);
                //servicePrice += element.pickupUnitPrice;
                let pickUpObj = element.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Delivery)[0];
                if (pickUpObj != null) {
                  servicePrice += pickUpObj.totalPrice;
                }
              }
              if (crossingBorderForm['ReturnToggle']) {
                //servicePrice += this.calculatePrice(element, false);
                //servicePrice += element.returnUnitPrice;
                let returnUpObj = element.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Receive)[0];
                if (returnUpObj != null) {
                  servicePrice += returnUpObj.totalPrice;
                }
              }
            }

            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

            }
            totalPrice += servicePrice;
            break
          case PredefinedAdditionalServiceEnum.CrossingBoarders:
            let borders = this.form.controls['s_' + element.additionalServiceID].value as CrossBorderModel[];
            //If its not Quantitative then calculate the service price if its not exist in the FreeService list
            // if (_freeService == null) {
            //   borders.forEach(element => {

            //     servicePrice += this.calculatePriceCrossingBorderViewMode(element);
            //   });
            // }
            servicePrice = element.totalPrice;

            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);
            }
            totalPrice += servicePrice;
            break
          default:


            if (element.isPhysicalAddon) {

              // if (_freeService != null && _freeService.quantity != null) {
              //   freeQuantity = _freeService.quantity;
              // }
              // //If the total of quaity is more than free , then start calculate the price
              // if (control.value > freeQuantity) {
              //   //We will start calculating from the first quantity after the free quantity number
              //   servicePrice = this.calculatePrice(element, true, (control.value - freeQuantity));
              // }
              servicePrice = element.totalPrice;
            }
            else {
              //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              if (_freeService == null) {
                //servicePrice = this.calculatePrice(element, false);
                servicePrice = element.totalPrice;
              }
            }

            //servicePrice = element.isPhysicalAddon ? this.calculatePrice(element, true, control.value) : this.calculatePrice(element, false);
            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);
            }
            totalPrice += servicePrice;
            break
        }
      }

    });

    console.log(this.lstPolicyReservationCaseModel);
    this.lstPolicyReservationCaseModel.forEach(res => {
      if (!res.isFree && res.isApply && res.policyDefinitionId != PolicyType.SecurityDepositPolicy && res.policyDefinitionId != PolicyType.CancelationPolicy)
        if (res.unitPrice != null && res.unitPrice > 0) {
          subTotal += res.unitPrice;
          this.taxableAmount += res.unitPrice;
        }
    })

    /*     if (this.ageResrictionPolicyFlag) {
          subTotal += this.ageRestrectionCharge;
          this.taxableAmount += this.ageRestrectionCharge;
        } */

    if (this.ezRent != null && this.ezRent.length > 0) {
      this.ezRent.forEach(item => {
        subTotal += item.unitPrice;
        this.taxableAmount += item.unitPrice;
      })

    }


    //Todo: add policy price to subtotal
    //Now the subtotal have the sum of additinal services price
    subTotal += totalPrice;
    this.subTotal = subTotal;




    let totalRentalTimeAfterDiscount;

    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
    ) {
      totalRentalTimeAfterDiscount = this.calculateDiscountRentalPeriod();
      this.subTotal += totalRentalTimeAfterDiscount;
      this.taxableAmount += totalRentalTimeAfterDiscount;
    }
    else {
      this.subTotal += this.totalRentalPrice;
      this.taxableAmount += this.totalRentalPrice;
    }




    /*The List outsideworking hour pickup/return  Comes after calculate the disscount*/
    if (this.lstVehicleReservationCaseNonWorkingHoursChargeModel != null) {

      this.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(element => {
        this.subTotal += element.unitPrice;
        if (element.isTaxable) {
          this.taxableAmount += element.unitPrice;
        }
      });
    }

    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.TotalCharges)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.TotalCharges)
      ||
      (this.agencyEmployeeAllowedDiscountsModel != null && this.agencyEmployeeAllowedDiscountsModel.discountScopeID == DiscountScopeEnum.TotalCharges)
    ) {
      let subTotalAfterDiscount = this.calculateDiscountTotalCharges();
      this.subTotal = subTotalAfterDiscount;
      this.taxableAmount = this.calculateDiscountTax();
    }


    this.subTotalBeforeDiscount = this.subTotal;
    //The manual Charge Comes after calculate the disscount
    /*Add manual charges for the total discounted price and for tax if it's taxable */
    if (this.manualCharges != null) {

      this.manualCharges.forEach(element => {
        this.subTotal += element.amount;
        if (element.isTaxable) {
          this.taxableAmount += element.amount;
        }
      });
    }



    //List of compensated items not included in tax and discount
    if (this.compensatedItems != null && this.compensatedItems.length > 0) {
      this.compensatedItems.forEach(item => {
        this.subTotal += item.compensationCharge;
      })
    }


    //The Damages + Fines + Accident is only applied on Total price (excluded from discount and tax)
    this.subTotal += this.getViolationsAndDamages();

    this.subTotal = Number(this.subTotal.toFixed(2));

    this.totalTax = this.taxableAmount * this.taxPercent;


    //Format the tax to be 2 digit .00
    this.totalTax = Number((Math.round(this.totalTax * 100) / 100).toFixed(2));
    this.onTotalCalculated.emit((this.subTotal + this.totalTax));
    this.calculateTotalResult = this.subTotal + this.totalTax;
    return this.subTotal + this.totalTax;
  }

  /*  Get Total of Damages + Fines + Accidents */
  getViolationsAndDamages(): number {
    let sumTotal = 0;
    if (this.lstDamages != null && this.lstDamages.length > 0) {
      this.lstDamages.forEach(item => {
        sumTotal += item.damageValue;
      })
    }

    if (this.lstAccident != null && this.lstAccident.length > 0) {
      this.lstAccident.forEach(item => {
        sumTotal += item.liabilityAmount;
      })
    }

    if (this.lstFines != null && this.lstFines.length > 0) {
      this.lstFines.forEach(item => {
        sumTotal += item.amount;
      })
    }
    return sumTotal;
  }

  calculateTotalForManualCharge(manualCharges: VehicleReservationCaseManualCharges[]) {
    /* manualCharges.forEach(element => {

      if (element.isTaxable) {
        this.taxableAmount = element.amount;
        this.totalPrice += element.amount;
        this.totalPrice += this.calculateTax(element.amount, this.taxPercent);
      }
      else {
        this.totalPrice += element.amount;
      }
    }); */
  }
  getBorders(additionalServiceID) {

    let borders = this.form.controls[this.formControlPrefix + additionalServiceID].value;

    return borders;
  }

  //#region Helpers

  doesItHaveDriverService(lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[]) {
    return lstAdditionalServiceReservationCase.find(o => o.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) != null;
  }
  doesItCrossingBorder(lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[]) {
    return lstAdditionalServiceReservationCase.find(o => o.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.CrossingBoarders) != null;
  }
  //#endregion

  //#region Discount

  calculateDiscountRentalPeriod() {

    let discount = 0;
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null && this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.RentalPeriod) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.totalRentalPrice;
    }
    else if (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.RentalPeriod) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.totalRentalPrice;
    }
    else if (this.agencyEmployeeAllowedDiscountsModel != null && this.agencyEmployeeAllowedDiscountsModel.discountScopeID == DiscountScopeEnum.RentalPeriod) {
      discountPrice += (this.agencyEmployeeAllowedDiscountsModel.discountPercentage / 100) * this.totalRentalPrice;
    }
    return this.totalRentalPrice - discountPrice;
  }

  calculateDiscountTotalCharges() {
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null && this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.subTotal;
    }
    else if (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.subTotal;
    }
    else if (this.agencyEmployeeAllowedDiscountsModel != null && this.agencyEmployeeAllowedDiscountsModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.agencyEmployeeAllowedDiscountsModel.discountPercentage / 100) * this.subTotal;
    }
    return this.subTotal - discountPrice;
  }

  calculateDiscountTax() {
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null && this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.taxableAmount;
    }
    else if (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.taxableAmount;
    }
    else if (this.agencyEmployeeAllowedDiscountsModel != null && this.agencyEmployeeAllowedDiscountsModel.discountScopeID == DiscountScopeEnum.TotalCharges) {
      discountPrice += (this.agencyEmployeeAllowedDiscountsModel.discountPercentage / 100) * this.taxableAmount;
    }
    return this.taxableAmount - discountPrice;
  }

  calculateDiscount() {

    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
    ) {
      this.calculateDiscountRentalPeriod();
    }
    else {
      this.calculateDiscountTotalCharges();
    }
  }

  getFreePolicies(model: VehicleReservationCaseDetailsModel) {
    if (model != null) {
      let freePolices = [];
      if (model.membershipModel != null && model.membershipModel.lstCustomerMembershipFreePolicies != null) {
        model.membershipModel.lstCustomerMembershipFreePolicies.forEach(element => {
          let _freePolicy: FreePolicy = {
            FreePolicyID: element.customerMembershipFreePolicyID,
            policyDefinitionID: element.policyDefinitionID,
            policyType: element.policyType,
            policyTypeName: element.policyTypeName,
            lang: element.lang
          }
          freePolices.push(_freePolicy);
        });
      }
      if (model.campaignsReservationCaseModel != null && model.campaignsReservationCaseModel.campaignFreePolicies != null) {
        model.campaignsReservationCaseModel.campaignFreePolicies.forEach(element => {
          let _freePolicy: FreePolicy = {
            FreePolicyID: element.campaignFreePolicyID,
            policyDefinitionID: element.policyDefinitionID,
            policyType: element.policyType,
            policyTypeName: element.policyTypeName,
            lang: element.lang
          }
          freePolices.push(_freePolicy);
        });

      }
      return freePolices;
    }
    return [];
  }

  getFreeServices(model: VehicleReservationCaseDetailsModel) {

    if (model != null) {
      let freeServices = [];
      if (model.membershipModel != null && model.membershipModel.lstMembershipAdditionalServices != null) {
        model.membershipModel.lstMembershipAdditionalServices.forEach(element => {
          let _freeService: FreeService = {
            additionalServiceID: element.additionalServiceID,
            predefinedAdditionalServiceID: element.predefinedAdditionalServiceID,
            isQuantitative: element.isQuantitative,
            quantity: element.quantity
          }
          freeServices.push(_freeService);
        });
      }
      if (model.campaignsReservationCaseModel != null && model.campaignsReservationCaseModel.campaignAdditionalServices != null) {
        model.campaignsReservationCaseModel.campaignAdditionalServices.forEach(element => {
          let _freeService: FreeService = {
            additionalServiceID: element.additionalServiceID,
            predefinedAdditionalServiceID: element.predefinedAdditionalServiceID,
            isQuantitative: element.isQuantitative,
            quantity: element.quantity
          }
          freeServices.push(_freeService);
        });
      }
      return freeServices;
    }
    return [];
  }

  //#endregion

  calculateAgeRestrictionPolicy(lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[]) {


    let agePolicy = lstPolicyReservationCaseModel.filter(o => o.policyDefinitionId == PolicyType.AgeRestrictionPolicy)[0];


    if (agePolicy != null && agePolicy.ageRestrictionPolicyModel != null) {

      let ageRestriction = agePolicy.ageRestrictionPolicyModel;

      if (ageRestriction.ageRestrictionType == AgeRestrictionPolicyTypes.ApplyChargesForSpecificAgeRangeAsARiskFactor) {

        if (ageRestriction.ageChargesList != null) {
          ageRestriction.ageChargesList.forEach(element => {
            if (this.customerAge >= element.ageFrom && this.customerAge <= element.ageTo) {
              this.ageResrictionPolicyFlag = true;
              //Check if age restrection have discount
              let _freePolicy = this.freePolicies.filter(o => o.policyDefinitionID == agePolicy.policyDefinitionId)[0];
              //IF Does not have discount then count the price else the price is 0
              if (_freePolicy == null) {
                this.ageRestrectionCharge = element.chargePercentage;
              }
              else {
                this.ageRestrectionCharge = 0;
              }

            }
          });
        }
      }
    }
  }

  //Check if the additional Service is free or not based on Campaign/Membership
  isFreeService(predefinedAdditionalServiceID) {

    let _freeService = this.freeServices.filter(o => o.predefinedAdditionalServiceID == predefinedAdditionalServiceID)[0];
    return _freeService != null;
  }

}
